import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    email: '',
    accountType: '',

  },
  mutations: {
    SET_EMAIL(state, payload) {
      state.email = payload.email;
      state.accountType = payload.accountType;
    },

  },
  actions: {
    setEmail({ commit }, data) {
      commit('SET_EMAIL', data);
    },
  },
});
